import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id B2FDC7FE-A762-45BE-9405-77F41514BAED
 * name vector-square-open
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-square-open.svg
 * tags
 * - Vector 
 */
export const VectorSquareOpenIcon = createSvgIcon(<><path d="M4 4H6V6H4V4M6 20H4V18H6V20M18 8V16H16V18H8V16H6V8H8V2H2V8H4V16H2V22H8V20H16V22H22V16H20V8H22V2H16V8H18M20 20H18V18H20V20M18 6V4H20V6H18Z" /></>, 'VectorSquareOpenIcon');
export default VectorSquareOpenIcon